import getApiClient from '../../../../plugins/api'

export default {
    checkAccess: function() {

    },

    loadSurvey: function() {
        const self = this,
            api = getApiClient(self.$store),
            id = self.$route.params.id

        self.$store.commit('startLoading')

        api.get(`surveys/${id}`)
        .then((result) => {
            self.survey = result.data
            if (self.editing) {
                self.surveyAnswers = {
                    placeObservations: self.survey.placeObservations ?? '',
                    observations: self.survey.observations ?? '',
                    tripRank: self.survey.tripRank ?? 0,
                    placeRank: self.survey.placeRank ?? 0,
                    agencyRank: self.survey.agencyRank ?? 0,
                    companyRank: self.survey.companyRank ?? 0
                }
            }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(() => {
            self.$store.commit('stopLoading')
        })
    },

    submitSurvey: function() {
        const self = this,
            api = getApiClient(self.$store),
            id = self.$route.params.id

        self.error = false
        self.success = false
        self.errorField = false

        self.$store.commit('startLoading')

        api.patch(`surveys/${id}`, self.surveyAnswers, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.error = false
                self.success = true
            })
            .catch(error => {
                self.success = false

                switch (error.response.status) {
                    case 400:
                    case 422:
                        self.error = false
                        self.errorField = true
                        break;
                    case 500:
                        self.error = true
                        self.errorField = false
                        break;
                }

                self.goFirstError()
            })
            .finally(() => {
                self.$store.commit('stopLoading')
            })
    },

    goFirstError() {
        const self = this
        window.setTimeout(function() {
            let firstError = document.getElementsByClassName('errors')[0]

            self.$scrollTo(firstError)
        }, 200)
    }
}
